import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { getAssessmentAttemptByUserId } from "../dashboard/actions";
import AdminUserDocuments from "./component";
import { updateUser } from "../settings/actions";
import AdminReactivateUser from "./component";
import { bulkReactivate } from "./actions";

const mapStateToProps = ({ funnelStep }) => ({
  funnelStep,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getAssessmentAttemptByUserIdConnect: getAssessmentAttemptByUserId,
      UpdateUserConnect: updateUser,
      bulkReactivateConnect: bulkReactivate,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AdminReactivateUser);
